import React, { useState, useEffect,useContext } from "react";
import './details.scss';
import { LeftDetails } from "./leftDetails";
import { RightDetails } from "./rightDetails";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export const Details = () => {

  const [fromBoards, setFromBoards] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setFromBoards(location.state?.fromBoards);
  }, []);

  const handleBackToBoards = () => {
    navigate(`/job-list/job-details/${location.state?.jobId}`, { state: { fromCandidateDetails: true } });
  };
 

  return (
   <section className="row h-100">
    {fromBoards && <div className="d-flex justify-content-end mb-3">
      <input className="btn btn-primary d-flex" type="button" value="Back to Boards" onClick={handleBackToBoards} />
    </div>}
    <div className="col-12 col-md-3 pe-4 left-details with-border position-relative top-0-right">
      <LeftDetails />
    </div>
    <div className="col-12 col-md-9 right-details">
      <RightDetails />
      </div>
   </section>
  );
}

